export function readmore() {
  return {
    loadAllContent: false,
    showbutton: false,

    init() {
      const vm = this;
      vm.countTextline();
    },
    countTextline() {
      const textDescription = this.$refs.desc;
      if (textDescription) {
        const textHeight = textDescription.scrollHeight;
        this.showbutton = textHeight > 238;
      }
    },
    toggleContent() {
      const vm = this;
      vm.loadAllContent = !vm.loadAllContent;
    }
  };
}
